module.exports = __webpack_public_path__ + "static/img/qq.ef113b97.png";